import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative bg-navy-dark text-white pt-20 pb-24 md:pt-32 md:pb-32 overflow-hidden" data-id="element-85">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-86">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-87">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-88">
            <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-6 leading-tight uppercase" data-id="element-89">
              Guía de <span className="text-gold-accent" data-id="element-90">Libertad Fiscal</span>
            </h1>
            <h2 className="text-xl md:text-2xl font-body font-semibold text-gray-300 mb-8 leading-relaxed" data-id="element-91">
              Deja de pagar "tarifas de guardián" para recuperar tu propio
              dinero. Declara tus impuestos por $0 y evita los cobros abusivos
              de preparadores y programas de software.
            </h2>
            <CTAButton href="#oferta" className="w-full md:w-auto text-center" data-id="element-92">
              OBTEN TU GUIA AHORA
            </CTAButton>
            <p className="mt-4 text-sm text-gray-400 font-body" data-id="element-93">
              Descarga instantánea. Acceso inmediato.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-94">
            <div className="absolute inset-0 bg-gold-accent opacity-20 blur-3xl rounded-full" data-id="element-95"></div>
            <img src="https://cdn.magicpatterns.com/uploads/rZm8m29KhcTyLFYsgddNCF/Imagen_de_producto_para_el_landing.png" alt="Guía de Libertad Fiscal en múltiples dispositivos" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-96" />
          </motion.div>
        </div>
      </div>
    </section>;
}